<div class="card">
    <div class="card-header">
        <h4>Super Transactions</h4>
    </div>
    <div class="card-body m-0">
        <div class="row">
            <label class="col-form-label" for="txnId">Transaction ID
            </label>
            <div class="col-sm-4">
                <input class="form-control" id="txnId" type="text" [(ngModel)]="searchTransactionId" name="txnId">
            </div>
            <div class="col-sm-4 mt-1">
                <button class="btn bg-danger-custom" type="button" (click)="searchTransaction()">
                    <i class="feather icon-search"></i> Search
                </button>
            </div>
        </div>
        <div *ngIf="searchedTransaction">
            <div class="row">
                <div class="col-sm-4">
                    <label class="col-form-label" for="senderWalletId">Debit Wallet ID</label>
                    <input class="form-control" readonly id="senderWalletId" type="text"
                        [(ngModel)]="searchedTransaction.senderWalletId" name="senderWalletId">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="senderMobileNumber">Sender Mobile Number</label>
                    <input class="form-control" readonly id="senderMobileNumber" type="text"
                        [(ngModel)]="searchedTransaction.senderMobileNumber" name="senderMobileNumber">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="senderName">Sender Name</label>
                    <input class="form-control" readonly id="senderName" type="text"
                        [(ngModel)]="searchedTransaction.senderName" name="senderName">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="receiverWalletId">Credit Wallet ID</label>
                    <input class="form-control" readonly id="receiverWalletId" type="text"
                        [(ngModel)]="searchedTransaction.receiverWalletId" name="receiverWalletId">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="receiverMobileNumber">Receiver Mobile Number</label>
                    <input class="form-control" readonly id="receiverMobileNumber" type="text"
                        [(ngModel)]="searchedTransaction.receiverMobileNumber" name="receiverMobileNumber">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="receiverName">Receiver Name</label>
                    <input class="form-control" readonly id="receiverName" type="text"
                        [(ngModel)]="searchedTransaction.receiverName" name="receiverName">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="senderVirtualIBAN">Sender IBAN</label>
                    <input class="form-control" readonly id="senderVirtualIBAN" type="text"
                        [(ngModel)]="searchedTransaction.senderVirtualIBAN" name="senderVirtualIBAN">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="channelId">Channel ID</label>
                    <input class="form-control" readonly id="channelId" type="text" [(ngModel)]="searchedTransaction.channelId"
                        name="channelId">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="transactionDate">Date of Transaction</label>
                    <input class="form-control" readonly id="transactionDate" type="text"
                        [(ngModel)]="searchedTransaction.transactionDate" name="transactionDate">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="receiverVirtualIBAN">Receiver IBAN</label>
                    <input class="form-control" readonly id="receiverVirtualIBAN" type="text"
                        [(ngModel)]="searchedTransaction.receiverVirtualIBAN" name="receiverVirtualIBAN">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="currency">Currency</label>
                    <input class="form-control" readonly id="currency" type="text" [(ngModel)]="searchedTransaction.currency"
                        name="currency">
                </div>
                <div class="col-sm-4">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="originalAmount">Amount</label>
                    <input class="form-control" readonly id="originalAmount" type="text"
                        [(ngModel)]="searchedTransaction.originalAmount" name="originalAmount">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="originalFee">Fee</label>
                    <input class="form-control" readonly id="originalFee" type="text"
                        [(ngModel)]="searchedTransaction.originalFee" name="originalFee">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="originalVat">VAT</label>
                    <input class="form-control" readonly id="originalVat" type="text"
                        [(ngModel)]="searchedTransaction.originalVat" name="originalVat">
                </div>
            </div>
            <form (ngSubmit)="save()" [formGroup]="saveSuperTransactionForm">
                <div class="row">
                    <div class="col-sm-4">
                        <label class="col-form-label" for="amountAmount">Amount</label>
                        <input class="form-control" id="amountAmount" type="text"
                            formControlName="amountAmount">
                        <div *ngIf="isFormSubmitted && saveSuperTransactionForm.controls.amountAmount.errors?.pattern" class="invalid-feedback" style="display: block">
                            Please Enter Valid Amount (Upto 2 Decimal Places)
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <label class="col-form-label" for="amountNarration">Narration</label>
                        <input class="form-control" id="amountNarration" type="text"
                            formControlName="amountNarration">
                        <div *ngIf="isFormSubmitted && saveSuperTransactionForm.controls.amountNarration.errors?.required" class="invalid-feedback" style="display: block">
                            Please Enter Narration
                        </div>
                        <div *ngIf="isFormSubmitted && saveSuperTransactionForm.controls.amountNarration.errors?.pattern" class="invalid-feedback" style="display: block">
                            Please Enter Valid Narration
                        </div>
                    </div>
                    <div class="col-sm-4">
                    </div>
                    <div class="col-sm-4">
                        <label class="col-form-label" for="feeAmount">Fee</label>
                        <input class="form-control" id="feeAmount" type="text"
                            formControlName="feeAmount">
                        <div *ngIf="isFormSubmitted && saveSuperTransactionForm.controls.feeAmount.errors?.pattern" class="invalid-feedback" style="display: block">
                            Please Enter Valid Amount (Upto 4 Decimal Places)
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <label class="col-form-label" for="feeNarration">Narration</label>
                        <input class="form-control" id="feeNarration" type="text"
                            formControlName="feeNarration">
                        <div *ngIf="isFormSubmitted && saveSuperTransactionForm.controls.feeNarration.errors?.required" class="invalid-feedback" style="display: block">
                            Please Enter Narration
                        </div>
                        <div *ngIf="isFormSubmitted && saveSuperTransactionForm.controls.feeNarration.errors?.pattern" class="invalid-feedback" style="display: block">
                            Please Enter Valid Narration
                        </div>
                    </div>
                    <div class="col-sm-4">
                    </div>
                    <div class="col-sm-4">
                        <label class="col-form-label" for="vatAmount">VAT</label>
                        <input class="form-control" id="vatAmount" type="text"
                            formControlName="vatAmount">
                        <div *ngIf="isFormSubmitted && saveSuperTransactionForm.controls.vatAmount.errors?.pattern" class="invalid-feedback" style="display: block">
                            Please Enter Valid Amount (Upto 4 Decimal Places)
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <label class="col-form-label" for="vatNarration">Narration</label>
                        <input class="form-control" id="vatNarration" type="text"
                            formControlName="vatNarration">
                        <div *ngIf="isFormSubmitted && saveSuperTransactionForm.controls.vatNarration.errors?.required" class="invalid-feedback" style="display: block">
                            Please Enter Narration
                        </div>
                        <div *ngIf="isFormSubmitted && saveSuperTransactionForm.controls.vatNarration.errors?.pattern" class="invalid-feedback" style="display: block">
                            Please Enter Valid Narration
                        </div>
                    </div>
                    <div class="col-sm-4">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <label class="col-form-label" for="reason">Reason</label>
                        <ng-select id="reason" formControlName="reason" placeholder="Select Reason" formControlName="reason">
                            <ng-option *ngFor="let reason of reasons"
                                value="{{reason}}">{{reason}}</ng-option>
                        </ng-select>
                        <div *ngIf="isFormSubmitted && saveSuperTransactionForm.controls.reason.errors?.required" class="invalid-feedback" style="display: block">
                            Please Select Reason
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <label class="col-form-label" for="remarks">Remarks</label>
                        <input class="form-control" id="remarks" type="text"
                            formControlName="remarks">
                        <div *ngIf="isFormSubmitted && saveSuperTransactionForm.controls.remarks.errors?.required" class="invalid-feedback" style="display: block">
                            Please Enter Remarks
                        </div>
                        <div *ngIf="isFormSubmitted && saveSuperTransactionForm.controls.remarks.errors?.pattern" class="invalid-feedback"
                            style="display: block">
                            Please Enter Valid Remarks
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 mt-2">
                        <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                </div>
            </form>
        </div>        
    </div>
</div>